// extracted by mini-css-extract-plugin
export default {"story__form_label":"YourStoryPage_story__form_label__II51i"};